import React from "react";
import { Parallax } from "react-parallax";
import {
	appliedConfig,
	HeaderConfig,
	IntroBgConfig,
	IntroContentConfig,
} from "../../../config/commonConfig";
import videobg from "../../../videos/lp-ead.mp4";
import WhatsAppButton from "../../WhatsAppButton";

function Intro2() {
	const applyOpacityAndMask = () => {
		if (appliedConfig.appliedIntroBg === IntroBgConfig.Default) {
			return "opacity-1 bg-primary";
		} else if (appliedConfig.appliedIntroBg === IntroBgConfig.Image) {
			return "opacity-5 bg-primary";
		} else {
			return "opacity-9 bg-dark";
		}
	};
	return (
		<section id="home">
			<div className="hero-wrap">
				<div className={"hero-mask  " + applyOpacityAndMask()} />
				{appliedConfig.appliedIntroBg === IntroBgConfig.Video && (
					<div className="player hero-bg ">
						<video
							src={videobg}
							autoPlay
							muted
							loop
							playsinline="true"
							style={{
								width: "100%",
								height: "100%",
								minHeight: "100%",
								objectFit: "cover",
							}}
						></video>
					</div>
				)}
				{appliedConfig.appliedIntroBg === IntroBgConfig.Image && (
					<div className="intro-parallax-container">
						<Parallax
							style={{
								width: "100%",
								height: "100%",
							}}
							bgImage="images/intro-bg.jpg"
							bgImageAlt="Intro"
							strength={200}
						>
							<div className="hero-bg parallax" />
						</Parallax>
					</div>
				)}

				<div
					className={
						"hero-content d-flex " +
						(appliedConfig.appliedHeader === HeaderConfig.ClassicHeader
							? "fullscreen-with-header "
							: "fullscreen pt-5 ") +
						(appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
						appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
							? "px-lg-5 "
							: " ")
					}
				>
					<div className="container my-auto">
						<div className="row my-5 my-lg-0">
							<div className="col-lg-6 align-self-center text-center text-lg-start order-1 order-lg-0">
								<h2
									className={
										"text-17 fw-600 mb-3 lh-1 " +
										(appliedConfig.appliedIntroBg === IntroBgConfig.Video ||
										appliedConfig.appliedIntroBg === IntroBgConfig.Image
											? "text-white "
											: " ")
									}
								>
									Lucre com{" "}
									<span
										className={
											appliedConfig.appliedIntroBg === IntroBgConfig.Default
												? "text-primary"
												: ""
										}
									>
										Cursos EAD de Trânsito
									</span>
								</h2>
								<p
									className={
										"lead mb-4 " +
										(appliedConfig.appliedIntroBg === IntroBgConfig.Video ||
										appliedConfig.appliedIntroBg === IntroBgConfig.Image
											? "text-white "
											: " ")
									}
								>
									Nós ajudamos você a aumentar o seu faturamento com um modelo
									de negócio inovador de revenda de cursos especializados para
									motoristas profissionais.
								</p>
								<WhatsAppButton />
							</div>
							{/* image content start */}
							{appliedConfig.appliedIntroContent ===
								IntroContentConfig.Image && (
								<div className="col-lg-6 d-flex align-items-center justify-content-center order-0 order-lg-1 mb-4 mb-lg-0">
									<img
										className="img-fluid"
										src="images/app-showcase.png"
										alt=""
									/>
								</div>
							)}
							{/* image content end */}

							{/* youtube content start */}
							{appliedConfig.appliedIntroContent ===
								IntroContentConfig.Video && (
								<div className="col-lg-6 align-self-center order-0 order-lg-1 mb-5 mb-lg-0">
									<div className="player shadow-lg rounded-lg ratio ratio-16x9">
										{/*
                      <iframe
                      src="https://player.vimeo.com/video/1127167426?badge=0&amp;muted=0&amp;byline=0&amp;autoplay=1&amp;player_id=0&amp;app_id=58479"
                      title="SEJA NOSSO PARCEIRO..."
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted"
                      allowfullscreen
                    ></iframe>
                      */}
                    <video
                      src={videobg}
                      autoPlay={true}
                      controls={true}
                      loop
                      playsinline="true"
                      muted={false}
                      style={{
                        width: "100%",
                        height: "100%",
                        minHeight: "100%",
                        objectFit: "cover",
                      }}
                    ></video>
									</div>
								</div>
							)}
							{/* youtube content end */}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Intro2;
